<aside
  class="sidebar flex-col space-between-center h-100"
  [attr.aria-label]="'SIDEBAR.NAVIGATION' | translate"
>
  <div class="sidebar-top flex-col w-100">
    <img
      class="lumana-logo invert-on-white"
      src="assets/icons/logo.svg"
      [alt]="'SIDEBAR.LUMANA_LOGO' | translate"
    />
    <hr class="divider" />
  </div>

  @if (isOrganizationRailExpanded) {
    <button
      type="button"
      class="drawer-close flex-row center-center"
      [attr.aria-label]="'SIDEBAR.CLOSE_ORGANIZATION_SELECTOR' | translate"
      (click)="closeOrganizationRail()"
    >
      <span class="ui-icon-close" aria-hidden="true"></span>
    </button>
  }

  <app-organization-menu
    (selectorOpenChange)="setOrganizationRailExpanded($event)"
  ></app-organization-menu>
</aside>
